import * as React from 'react';
import { detectFlexGapSupported } from '../styleChecker';
export default (() => {
  const [flexible, setFlexible] = React.useState(false);
  React.useEffect(() => {
    setFlexible(detectFlexGapSupported());
  }, []);
  return flexible;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/hooks/useFlexGapSupport.js
// module id = 767
// module chunks = 0